import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["container", "chevron", "content"];

  toggle({ target }) {
    const index = this.containerTargets.indexOf(
      target.closest('[data-faq-target="container"]')
    );
    this.chevronTargets[index].classList.toggle("rotate-180");
    this.contentTargets[index].classList.toggle("hidden");
  }
}
